var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"twitters"}},[_c('h1',{attrs:{"id":"widget__text"}},[_vm._v(" みんなの投稿")]),_vm._v(" "),_c('div',{attrs:{"id":"widget__container"}},[_c('Timeline',{attrs:{"id":"Q18807506","sourceType":"profile","options":{'height': 450}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33088ba5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Twitter.vue
// module id = null
// module chunks = 